import React, { useState } from 'react';
import { Modal, Checkbox, Row, Col } from 'antd';
import { useConfig } from '../../config';

const SettingsModal = ({modalVisible,setModalVisible}) => {
      const { config, updateConfig } = useConfig();
    
  const [checkedItems, setCheckedItems] = useState(config);



  const handleOk = () => {
    updateConfig(checkedItems)
    setModalVisible(false);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const onCheckboxChange = (e) => {
    setCheckedItems({
      ...checkedItems,
      [e.target.name]: e.target.checked
    });
  };

  return (
    <>
    
      <Modal
        title="Config Settings"
        open={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
        cancelText="Cancel"
        width={'250px'}
      >
        <div className="pt-4 py-2 border-t border-grey">
        <Row justify="space-between" align="middle" style={{ marginBottom: '10px' }}>
          <Col>Tree View</Col>
          <Col>
            <Checkbox
              name="treeView"
              checked={checkedItems.treeView}
              onChange={onCheckboxChange}
            />
          </Col>
        </Row>

        {/* Setting Item: Right Panel */}
        <Row justify="space-between" align="middle" style={{ marginBottom: '10px' }}>
          <Col>Right Panel</Col>
          <Col>
            <Checkbox
              name="RightPanel"
              checked={checkedItems.RightPanel}
              onChange={onCheckboxChange}
            />
          </Col>
        </Row>

        {/* Setting Item: Front Modal */}
        <Row justify="space-between" align="middle" style={{ marginBottom: '10px' }}>
          <Col>FrontMatter Modal</Col>
          <Col>
            <Checkbox
              name="FrontModal"
              checked={checkedItems.FrontModal}
              onChange={onCheckboxChange}
            />
          </Col>
        </Row>
        </div>
      </Modal>
    </>
  );
};

export default SettingsModal;
